import blank from '@/components/blank'
import recharge from './recharge'
import withdraw from './withdraw'
import addBankCard from './addBankCard'
import unbundingBankCard from './unbundingBankCard'
import about from './about'
import wallet from './wallet'
import material from './material'
import authIndex from './authIndex'
import resetPayPassword from './resetPayPassword'
import resetPassword from './resetPassword'
import changePayPassword from './changePayPassword'
import userInfo from './userInfo'
import checkFailed from './checkFailed'
import checkPending from './checkPending'
import profileCheckPending from './profileCheckPending'
import myBankCards from './myBankCards'
import profile from './profile'
import billDetails from './billDetails'
export default {
  path:'/',
  component:blank,
  meta:{title:'我的'},
  children:[
    {
      meta:{title:'关于',keepAlive:true},
      path:'about',
      component:about,
      name:'about',
    },
    {
      meta:{title:'我的资产',keepAlive:true},
      path:'wallet',
      component:blank,
      children: [
        {
          path:'/',
          name:'wallet',
          component:wallet,
          meta:{keepAlive:true},
        },
        {
          meta:{title:'充值'},
          path:'recharge',
          name:'recharge',
          component:recharge,
        },
        {
          meta:{title:'提现'},
          path:'withdraw',
          name:'withdraw',
          component:withdraw
        },
        {
          meta:{title:'添加银行卡'},
          path:'addBankCard',
          name:'addBankCard',
          component:addBankCard,
        },
        {
          meta:{title:'解除银行卡'},
          path:'unbundingBankCard',
          name:'unbundingBankCard',
          component:unbundingBankCard
        }
      ]
    },
    {
      meta:{title:'我的银行卡'},
      path:'myBankCards',
      component:myBankCards,
      children: [
        {
          path:'/',
          name:'myBankCards',
          component:myBankCards,
          meta:{keepAlive:true},
        },
        {
          meta:{title:'添加银行卡'},
          path:'addBankCard',
          name:'addBankCard',
          component:addBankCard,
        },
        {
          meta:{title:'解除银行卡'},
          path:'unbundingBankCard',
          name:'unbundingBankCard',
          component:unbundingBankCard
        }
      ]
    },
    {
      meta:{title:'我的材料',keepAlive:true},
      path:'material',
      component:material,
      name:'material'
    },
    {
      meta:{title:'我的认证',keepAlive:true},
      path:'authIndex',
      component:authIndex,
      name:'authIndex'
    },
    {
      meta:{title:'支付密码重置',keepAlive:true},
      path:'resetPayPassword',
      component:resetPayPassword,
      name:'resetPayPassword'
    },
    {
      meta:{title:'密码修改',keepAlive:true},
      path:'resetPassword',
      component:resetPassword,
      name:'resetPassword'
    },
    {
      meta:{title:'支付密码修改',keepAlive:true},
      path:'changePayPassword',
      component:changePayPassword,
      name:'changePayPassword'
    },
    {
      meta:{title:'完善用户信息',keepAlive:true},
      path:'userInfo',
      component:userInfo,
      name:'userInfo'
    },
    {
      meta:{title:'信息审核失败',keepAlive:true},
      path:'checkFailed',
      component:checkFailed,
      name:'checkFailed',
    },
    {
      meta:{title:'信息审核中',keepAlive:true},
      path:'checkPending',
      component:checkPending,
      name:'checkPending'
    },
    {
      meta:{title:'资料信息审核中',keepAlive:true},
      path:'profileCheckPending',
      component:profileCheckPending,
      name:'profileCheckPending'
    },
    {
      meta:{title:'我的资料',keepAlive:true},
      path:'profile',
      component:profile,
      name:'profile'
    },
    {
      meta:{title:'我的账单详情',keepAlive:true},
      path:'billDetails',
      component:billDetails,
      name:'billDetails'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/pages/myProfile/route.js